import { render, staticRenderFns } from "./tietosuojaseloste-content.vue?vue&type=template&id=1de958cc&"
import script from "./tietosuojaseloste-content.vue?vue&type=script&lang=ts&"
export * from "./tietosuojaseloste-content.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports